import styled, { css } from 'styled-components';
import { Link } from 'react-router-dom';
import { color, size, animation } from '../helpers/variables';
import { fontFamilyHeading, dynamicFontSize } from '../helpers/mixins';

export const InformationCardBlock = {};

InformationCardBlock.Container = styled(Link)`
  width: 100%;
  display: flex;
  text-decoration: none;
  color: inherit;
  margin-bottom: 50px;
  flex-direction: column;

  @media screen and (min-width: ${size.large}px) {
    margin-bottom: 20px;
  }

  ${props =>
    props.lastChild &&
    css`
      margin-bottom: 0;
    `};
`;

InformationCardBlock.Content = styled.div`
  flex: 1;
`;

InformationCardBlock.ImageContainer = styled.div`
  position: relative;
  z-index: 1;
  margin-right: 0;
  margin-bottom: 22px;
  height: 100%;
  &:after {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.2);
    z-index: 999;
    opacity: 0;
    transition: opacity ${animation.transitionTime} ${animation.easing};
  }

  ${InformationCardBlock.Container}:hover & {
    &:after {
      opacity: 1;
    }
  }
`;

InformationCardBlock.Image = styled.img`
  display: block;
  width: 100%;
  height: auto;
`;

InformationCardBlock.Title = styled.p`
  font-weight: 600;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 0.9px;
  color: #a7a7a7;
  text-transform: uppercase;
  margin: 0;
  font-size: 12px;
  text-align: center;
`;

InformationCardBlock.Label = styled.p`
  ${fontFamilyHeading};
  ${dynamicFontSize(26, 30, size.small, size.xLarge)};
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.38;
  letter-spacing: normal;
  color: ${color.black};
  text-align: center;
  margin: 12px 0 0;
`;



// WEBPACK FOOTER //
// ./src/styles/blocks/InformationCardBlock.js